window.wow = new WOW({
    mobile: false
});
wow.init();
$(function () {
    //sheet link animations
    var sheetLinks = $('.sheet-links a');
    var animationLocked = false;
    var lastTarget;
    var animationTarget;

    function animateSheetLinks() {
        sheetLinks
            .on('mouseenter.sheetLink', function () {
                lastTarget = this;
                if (!animationLocked) {
                    runAnimation(this);
                }
            })
            .on('mouseleave.sheetLink', function () {
                lastTarget = null;
                if (this.timeline && this === animationTarget) {
                    this.timeline.reverse();
                }
            });
    }

    function lockAnimation() {
        animationLocked = true;
    }

    function unlockAnimation() {
        animationLocked = false;
        if (lastTarget) {
            runAnimation(lastTarget);
        }
    }

    function runAnimation(target) {
        animationTarget = target;
        if (target.timeline) {
            target.timeline.play();
        }
        else {
            target.timeline = new TimelineLite();
            var element = $(target);
            var circle = element.find('circle');
            var arrow = element.find('.arrow');
            var line = element.find('.line');
            target.timeline
                .set(circle, { stroke: '#FFF', strokeWidth: 2 })
                .set(arrow, { x: -8 })
                .from(circle, .2, { drawSVG: 0 })
                .set(element, { flexShrink: 0, flexGrow: 0, onReverseComplete: unlockAnimation, onComplete: lockAnimation })
                .to(line, .15, { width: '50%' })
                .to(arrow, .1, { delay: -.1, opacity: 1, x: 0 })
                .fromTo(element, .15, { flexBasis: (100 / sheetLinks.length) + '%' }, { delay: -.2, flexBasis: '30%' });
            target.timeline.progress(1);
            target.timeline.progress(0);
            target.timeline.play();
        }
    }

    $(window).on('changed.zf.mediaquery', function (event, newSize) {
        if (newSize === 'small') {
            sheetLinks.off('mouseenter.sheetLink mouseleave.sheetLink');
        }
        else {
            animateSheetLinks();
        }
    });
    if (Foundation.MediaQuery.current !== 'small') {
        animateSheetLinks();
    }

});